/**
 * Mounts hero background video only when safe for WebKit memory.
 * iPhone / iPad keep the poster image unless the section explicitly allows iOS video.
 */
(function () {
  function isAppleTouchDevice() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/i.test(ua)) return true;
    // iPadOS desktop UA
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    return false;
  }

  function shouldEnableVideo(root) {
    if (!root) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    var allowIos = root.getAttribute('data-enable-on-ios') === 'true';
    if (isAppleTouchDevice() && !allowIos) return false;

    // Theme editor: always allow so merchants can preview the video.
    if (window.Shopify && window.Shopify.designMode) return true;

    return true;
  }

  function activate(root) {
    if (!root || root.getAttribute('data-video-hero-ready') === 'true') return;

    var template = root.querySelector('[data-video-hero-template]');
    var media = root.querySelector('.video-hero__media');
    if (!template || !media) return;

    if (!shouldEnableVideo(root)) {
      root.setAttribute('data-video-hero-ready', 'true');
      return;
    }

    var node = template.content.cloneNode(true);
    media.appendChild(node);

    var video = media.querySelector('video');
    if (video) {
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('aria-hidden', 'true');
      video.play().catch(function () {
        /* Autoplay blocked — keep poster visible */
      });
      root.classList.add('video-hero--playing');
    }

    root.setAttribute('data-video-hero-ready', 'true');
  }

  function init() {
    document.querySelectorAll('[data-video-hero]').forEach(activate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-video-hero]')
      : null;
    if (root) activate(root);
  });
})();
